import React, { useEffect, useState } from 'react';
import {
    Box,
    Breadcrumbs,
    Typography,
} from "@mui/material";
import { useDataAuth } from '../../../hooks/useDataAuth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNotification } from '../../../hooks/useNotification';
import LoadingOverlay from '../../../components/others/LoadingOverlay';

export const LayoutApproval = ({  }) => {
    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
 

    useEffect(() => {
        if (location?.state && location.state.config) {
            console.log("locatin ", location.state);

        }
    }, [dispatch, location.state, userSession.token])


    return (
        <>
            {/* <Grid container justifyContent="flex-end">
                <Grid>
                    <IconButton color="primary" onClick={onAddClick}>
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid> */}

            <Box sx={{ width: '100%' }}>
                <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
                            <Link to="/tableViews/:params" underline="hover" color="text.main" sx={{ cursor: 'pointer' }}>
                                <Typography sx={{ fontWeight: 'bold' }}>
                                    Reglas Aprobacion
                                </Typography>
                            </Link>
                        </Breadcrumbs>
                    </Box>
                </Box>
            </Box>
            {/* <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            /> */}
            <LoadingOverlay isOpen={loading} />
        </>
    );
};